<template>
    <b-col md="12" align="center" class="tt-video">
        <b-overlay :show="show" rounded="sm">
            <template #overlay>
                <div class="text-center">
                    <div class="h2 mb-0">
                        <b-icon-watch font-scale="3" animation="cylon" />
                    </div>
                    <h2 class="text-dark">Cargando ...</h2>
                </div>
            </template>
            <div id="my-player" />
        </b-overlay>
    </b-col>
</template>

<script>
import { BRow, BCol, BOverlay, BIconWatch } from "bootstrap-vue";
import { useCast } from "./useCast";

export default {
    components: {
        BRow,
        BCol,
        BOverlay,
        BIconWatch
    },
    props: {
        canal: {
            type: Object,
            default: () => {},
            require: true
        },
        infoPlayer: {
            type: Object,
            default: () => {},
            require: true
        }
    },
    data() {
        return {
            show: true,
            canales: [],
            playList: [],
            cast: null
        };
    },
    created() {
        this.getCanales();
        this.loadScript();
    },
    methods: {
        async getCanales() {
            this.$http
                .get("/api/canal", {
                    params: {
                        estado: "A",
                        idcanaltipo: 1,
                        oplive: true
                    }
                })
                .then(response => {
                    this.canales = response.data.data;

                    if (this.canales) {
                        this.playList.push({
                            title: this.canal.nombre,
                            file: this.canal.path_play
                        });

                        for (let i = 0; i < this.canales.length; i++) {
                            if (this.canales[i].idcanal != this.idcanal) {
                                this.playList.push({
                                    title: this.canales[i].nombre,
                                    file: this.canales[i].path_play
                                });
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadScript() {
            const script = document.createElement("script");
            script.async = true;
            script.src = this.infoPlayer.script;
            document.head.appendChild(script);
            setTimeout(() => {
                this.loadPlayer();
            }, 3000);
            //this.loadPlayer();
        },
        loadPlayer() {
            this.show = false;
            new Playerjs({
                id: "my-player",
                file: this.playList,
                title: this.canal.nombre
            });
        },
        castJs() {
            const { CastPlayer } = useCast();

            var castPlayer = new CastPlayer();
            window["__onGCastApiAvailable"] = function(isAvailable) {
                if (isAvailable) {
                    castPlayer.initializeCastPlayer();
                }
            };

            console.log(castPlayer);
        }
    }
};
</script>

<style lang="css" scoped>
.tt-video {
    width: 100%;
    height: 100%;
}

#castbutton {
    float: right;
    margin: 10px 6px 14px 0px;
    width: 40px;
    height: 32px;
    opacity: 0.7;
    background-color: #000;
    border: none;
    outline: none;
}

#castbutton:hover {
    --disconnected-color: white;
    --connected-color: white;
}
</style>
